const statusCode = {
    success: 1,
    error: 0,
}
export {
    statusCode
}